import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IExamdate } from "../../../Pages/ExamDate/IExamDate";

export const DeleteExamdateSlice = createSlice({
  name: "DeleteExamdate",
  initialState: {} as IReduxState<IExamdate>,
  reducers: {
    deleteExamdate: (state, _) => {
      state.isLoading = true;
    },
    successdeleteExamdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failuredeleteExamdate: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearDeleteExamdateResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  deleteExamdate,
  failuredeleteExamdate,
  successdeleteExamdate,
  clearDeleteExamdateResponse,
} = DeleteExamdateSlice.actions;

export default DeleteExamdateSlice.reducer;
